/**
 * Field wrapper: label + body + caption/error.
 * @param {{ label?: string, required?: boolean, error?: string|null, caption?: string, children?: any }} props
 */
export default function Field({ label, required = false, error, caption, children }) {
  return (
    <label style={{ display: 'block', scrollMarginTop: 80 }}>
      {label && (
        <div
          style={{
            fontSize: 'var(--ab-text-xs)',
            fontWeight: 'var(--ab-weight-semi)',
            color: error ? 'var(--ab-denied)' : 'var(--ab-fg)',
            marginBottom: 4,
          }}
        >
          {label}
          {required && <span style={{ color: 'var(--ab-denied)', marginLeft: 4 }}>*</span>}
        </div>
      )}
      {children}
      {error && (
        <div style={{ fontSize: 'var(--ab-text-xs)', color: 'var(--ab-denied)', marginTop: 4 }}>
          {error}
        </div>
      )}
      {!error && caption && (
        <div style={{ fontSize: 'var(--ab-text-xs)', color: 'var(--ab-fg-subtle)', marginTop: 4 }}>
          {caption}
        </div>
      )}
    </label>
  );
}
